import { configureStore } from "@reduxjs/toolkit";
import hejalSlice from '../redux/hejalSlice';
import cartSlice from '../redux/cartSlice';
import wishlistSlice from "../redux/wishlistSlice"

const store = configureStore({
  reducer: {
    hejal: hejalSlice,
    cart: cartSlice,
    wishlist : wishlistSlice
  }
});

export default store;
